import { render, staticRenderFns } from "./WorkspaceCustomInput.vue?vue&type=template&id=b0348cf2"
import script from "./WorkspaceCustomInput.vue?vue&type=script&lang=js"
export * from "./WorkspaceCustomInput.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceCustomInput.vue?vue&type=style&index=0&id=b0348cf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports